window.AREPA = (function () {
    return {};
})();

// Global Event bus for emitting and receiving events
var EventBus = new Vue();